/**
 * 根据单号跳转订单详情
 */
import { useCallback } from 'react';
import { useHistory, generatePath } from 'react-router-dom';
import { message } from 'antd';
import intl from 'react-intl-universal';
import { OrderType, MainOrderStatus } from '@/config/constant';
import { orderPageKey } from '@/pages/order/help';

// 详情页
export const OrderDetailPageList = [
  // 房间订单
  {
    type: OrderType.roomBillOrder,
    route: '/order/room-order/:resvNo',
    paramKey: 'resvNo',
    bizCode: 'reservation',
  },
  // 增值业务
  {
    type: OrderType.receptionConsume,
    route: '/order/front-desk/detail/:orderNo',
    paramKey: 'orderNo',
    bizCode: 'receptionConsume',
  },
  // 商品直售
  {
    type: OrderType.receptionGoods,
    route: '/order/front-goods-order/detail/:orderNo',
    paramKey: 'orderNo',
    bizCode: 'receptionGoods',
  },
  // 自助点餐
  {
    type: OrderType.goodsSelfService,
    route: '/order/self-service/detail/:orderNo',
    paramKey: 'orderNo',
    bizCode: 'goodsSelfService',
  },
  // 会员卡
  {
    type: OrderType.memberCard,
    route: '/order/member-card/detail/:orderNo',
    paramKey: 'orderNo',
    bizCode: 'memberCard',
  },
  // 会员充值
  {
    type: OrderType.rechargeOrder,
    route: '/order/member-recharge/detail/:orderNo',
    paramKey: 'orderNo',
    bizCode: 'rechargeOrder',
  },
];

interface RouteState {
  tabKey: any; // 指定tab
  fromUrl: string; // 來源
}

export default () => {
  const history = useHistory();

  // 跳转订单详情
  const linkToOrderDetail = useCallback(
    (orderType: OrderType, orderNo: string, state?: Partial<RouteState>) => {
      if (!orderNo) {
        message.error(intl.get('hooks_order_no_empty'));
        return;
      }

      const orderItem = OrderDetailPageList.find((item) => item.type === orderType);

      if (orderItem) {
        history.push(generatePath(orderItem.route, { [orderItem.paramKey]: orderNo }), {
          fromUrl: window.location.pathname,
          ...(state || {}),
        });
      }
    },
    [],
  );

  // 跳转房间订单列表
  const linkToReservationList = useCallback((type: MainOrderStatus) => {
    const orderType = {
      [MainOrderStatus.ReservationOrder]: orderPageKey.reservation,
      [MainOrderStatus.CancelReservationOrder]: orderPageKey.cancelReservation,
      [MainOrderStatus.CheckinOrder]: orderPageKey.checkIn,
      [MainOrderStatus.CheckoutOrder]: orderPageKey.checkOut,
    }[type];
    history.push('/order/room-order', {
      orderTabKey: orderType,
    });
  }, []);

  // 跳转房间订单详情
  const linkToReservationDetail = useCallback((orderNo: string, state?: Partial<RouteState>) => {
    linkToOrderDetail(OrderType.roomBillOrder, orderNo, state);
  }, []);

  // 跳转订单列表
  // const linkToOrderList = useCallback((orderType: OrderType) => {
  //   // 暂时用不到
  // }, []);

  return { linkToOrderDetail, linkToReservationDetail, linkToReservationList };
};
